import DashboardLayout from "../../lib/components/layouts/dashboard";
import morning_img_02 from "../../assets/images/morning-img-02-grey.png";
import { Col, Image, Row } from "react-bootstrap";

import AppointmentsList from "../../lib/components/appointments/appointment-list";
import { useContext, useEffect, useState } from "react";
import TimeRemaining from "../../lib/components/charts/time-remaining";
import DashboardWidget from "lib/components/common/dashboard/dashboard-widget";

import { ADMIN_DASHBOARD_TILES } from "lib/data/dummy-widget-data";
import { PAGE_ROUTES } from "lib/constants/page-routes";

import { AppContext } from "lib/contexts/app-context";
import SimpleGreeting from "lib/components/common/simple-greeting";
import useAnalytics from "lib/hooks/useAnalytics";
import usePractitioner from "lib/hooks/usePractitioner";
import { getDatesArray, getNearestTime } from "lib/utils/date-utils";
import { getTimeDifference } from "lib/utils/date-utils";
import { getArrayOfValuesFromArray } from "lib/utils/array-utils";
import useClock from "lib/hooks/useClock";
import SimpleCard from "lib/components/common/simple-card";
import SimpleButton from "lib/components/common/simple-button";

const breadcrumbItems: BreadcrumbItem[] = [
  { label: "Dashboard", path: PAGE_ROUTES.PRACTITIONER.Dashboard },
];

const PractitionerDashboard = () => {

  const [timeRemainingForNextAppointment, setTimeRemainingForNextAppointment] =
    useState<number>(0);
  const [appointmentDetails, setAppointmentDetails] = useState<Appointment[]>(
    []
  );

  const { appState } = useContext(AppContext);
  const {
    getPractitionerAppointments,
    getPractitionerClinics,
    getPractitionerSubscriptions,
    getPractitionerEarnings,
    loading: analyticsLoading,
  } = useAnalytics();
  const { loading, error, getAllBookingsDetails } = usePractitioner();
  const [dashboardWidgetTiles, setDashboardWidgetTiles] = useState<
    DashboardWidget[]
  >(ADMIN_DASHBOARD_TILES);

  const allAppointmentTimes = getDatesArray(getArrayOfValuesFromArray(appointmentDetails, "date"));

  const getNextAppointmentTime = () => {

    if (allAppointmentTimes.length > 0) {
      const nearestAppointment = getNearestTime(allAppointmentTimes);

      return getTimeDifference(nearestAppointment);
    } else {
      return 0;
    }
  }


  useEffect(() => {
    if (appState) {
      getAllBookingsDetails(appState?.user_id, setAppointmentDetails);

      getPractitionerAppointments(appState?.user_id, (value) => {
        const updatedTiles = Array.from(dashboardWidgetTiles);
        updatedTiles[0].count = value?.currentMonthAppointments ?? 0;
        updatedTiles[0].total = value?.totalAppointments ?? 0;

        setDashboardWidgetTiles(updatedTiles);
      });

      getPractitionerClinics(appState?.user_id, (value) => {
        const updatedTiles = Array.from(dashboardWidgetTiles);
        updatedTiles[1].count = value.totalClinics;

        setDashboardWidgetTiles(updatedTiles);
      });

      getPractitionerSubscriptions(appState?.user_id, (value) => {
        const updatedTiles = Array.from(dashboardWidgetTiles);
        updatedTiles[2].count = value.totalSubscriptions;

        setDashboardWidgetTiles(updatedTiles);
      });

      getPractitionerEarnings(appState?.user_id, (value) => {
        const updatedTiles = Array.from(dashboardWidgetTiles);
        updatedTiles[3].count = value.totalEarnings;

        setDashboardWidgetTiles(updatedTiles);
      });
    }
  }, [appState]);

  useEffect(() => {
    setTimeRemainingForNextAppointment(getNextAppointmentTime());
  }, [appointmentDetails]);

  const handleNextAppointmentTick = () => {
    setTimeRemainingForNextAppointment(getNextAppointmentTime());
  };

  return (
    <DashboardLayout
      breadcrumbItems={breadcrumbItems}
    //isUnavailable={practitionerSubscriptionState.status === "success"}
    >
      <div className="good-morning-blk">
        <Row>
          <Col md={8}>
            <div className="morning-user">
              <SimpleGreeting name={appState?.name} />
              <p>Have a nice day at work</p>
            </div>
          </Col>
          <Col md={4}>
            <div className="morning-img">
              <Image src={morning_img_02} alt="" />
            </div>
          </Col>
        </Row>
      </div>
      <div className="">
        <Row>
          {dashboardWidgetTiles.map((widget, index) => (
            <Col sm="3" key={index}>
              <DashboardWidget {...widget} loading={analyticsLoading} />
            </Col>
          ))}
        </Row>
      </div>
      <Row>
        <Col sm={12} xl={8} xxl={9}>
          <AppointmentsList
            title="Today's appointments"
            appointments={appointmentDetails}
            isLoading={loading}
            error={error}
          />
        </Col>
        <Col sm={12} xl={4} xxl={3}>
          <TimeRemaining
            timeRemainingInMins={timeRemainingForNextAppointment}
            onTick={handleNextAppointmentTick}
          />
        </Col>
      </Row>
    </DashboardLayout>
  );
};

export default PractitionerDashboard;
